import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { DefaultResponseWithData } from "../models/system";
import {
  AccountAddressCreateEditRequest,
  IAccountAddress,
} from "../models/account/IAccountAddress";
import apiConfig from "../utils/apiConfig";

export default function useAccountAddresses(accountId?: string, componentName = "useAccountAddresses") {
  const { get, post, del } = useApiHelper(apiConfig(componentName));
  const queryClient = useQueryClient();

  const accountAddresses = useQuery({
    queryKey: ["accounts", accountId, "addresses"],
    queryFn: () =>
      get<DefaultResponseWithData<IAccountAddress[]>>(
        `/account/${accountId}/address`
      ),
    enabled: !!accountId,
  });

  const create = useMutation({
    mutationFn: (data: AccountAddressCreateEditRequest) =>
      post<
        AccountAddressCreateEditRequest,
        DefaultResponseWithData<IAccountAddress[]>
      >(`/account/${accountId}/address`, data),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: ["accounts", accountId, "addresses"],
      }),
  });

  const remove = useMutation({
    mutationFn: (data: { addressId: string }) =>
      del(`/account/${accountId}/address/${data.addressId}`),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: ["accounts", accountId, "addresses"],
      }),
  });

  return {
    accountAddresses,
    create,
    remove,
  };
}
